/**
 * Backend tenantMiddleware ile ayni subdomain kurallari.
 * Orn. quick.raborisk.ai -> "quick", www.quick.raborisk.ai -> "quick", quick.localhost -> "quick"
 */
export function getTenantSubdomain() {
  const hostname = (window.location.hostname || "").toLowerCase();
  if (!hostname) return null;
  if (/^\d{1,3}(\.\d{1,3}){3}$/.test(hostname)) return null;

  const parts = hostname.split(".");

  if (parts.length >= 2 && parts[parts.length - 1] === "localhost") {
    const sub = parts[0];
    if (!sub || sub === "www") return null;
    return sub;
  }

  if (parts.length >= 4 && parts[0] === "www") {
    const sub = parts[1];
    if (sub && sub !== "www") return sub;
  }

  if (parts.length < 3) return null;
  const sub = parts[0];
  if (!sub || sub === "www") return null;
  return sub;
}

export function isSuperAdminProfile(profile) {
  return Number(profile?.is_super_admin) === 1;
}

/** Redux state or API payload -> always a user array (never crash .filter/.forEach). */
export function ensureAdminUsersList(value) {
  if (Array.isArray(value)) return value;
  if (Array.isArray(value?.users)) return value.users;
  return [];
}

export function normalizeAdminUsersPayload(data) {
  if (Array.isArray(data)) {
    return { users: data, viewer: null };
  }
  return {
    users: ensureAdminUsersList(data),
    viewer: data?.viewer || null,
  };
}
